import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import BaseTableNew from 'components/atoms/base-table/new';
import BasePagination from 'components/atoms/base-pagination';
import EmptyTablePlaceholder from 'components/atoms/base-empty-table-placeholder';
import { scrollToTopAsync } from 'infrastructure/functions';
import {
  PATIENT_ENGAGEMENT_REPORT_PER_PAGE,
  useGetPatientEngagementReport,
} from 'infrastructure/hooks/patient-engagement-report';

import { columns } from './columns';
import s from './styles.module.scss';

import type { TPatientEngagementReportFilter } from 'infrastructure/hooks/patient-engagement-report';

interface IProps {
  filter: TPatientEngagementReportFilter;
  updateFilter: (newFilter: Partial<TPatientEngagementReportFilter>) => void;
}

const TABLE_ID = 'patient-engagement-status-report-table';

const PatientEngagementReportTable: FC<IProps> = ({ filter, updateFilter }) => {
  const { t } = useTranslation();
  const { data, total, isLoading } = useGetPatientEngagementReport(filter);

  return (
    <div className={s.wrapper} id={TABLE_ID}>
      <div className={s.header}>
        <BasePagination
          page={filter.page}
          total={total}
          align="end"
          onChange={(newPage) => {
            scrollToTopAsync(TABLE_ID, 70).then(() => {
              updateFilter({ page: newPage });
            });
          }}
          pageSize={PATIENT_ENGAGEMENT_REPORT_PER_PAGE}
          pageSizeOptions={[]}
          hide={false}
          showSizeChanger={false}
        />
      </div>
      <BaseTableNew
        dataCy="patient-engagement-status-report-table"
        loading={isLoading}
        columns={columns}
        items={data}
        rowKey="patientGuid"
        bordered
        pagination={{
          current: filter.page,
          pageSize: PATIENT_ENGAGEMENT_REPORT_PER_PAGE,
          total,
          position: ['bottomCenter'],
        }}
        onChangePage={(newPage) => {
          scrollToTopAsync(TABLE_ID, 70).then(() => {
            updateFilter({ page: newPage });
          });
        }}
        emptyText={
          <EmptyTablePlaceholder
            text={t('patientEngagementReport.noPatientsFound')}
            column
          />
        }
        rowHoverable={false}
      />
    </div>
  );
};

export default PatientEngagementReportTable;
